
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/write-to-us",
      function () {
        return require("private-next-pages/write-to-us/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/write-to-us"])
      });
    }
  